import { parseDomain } from "@certn/legacy-api";
import { components } from "@certn/legacy-api/generated-schemas/people";

import constants from "../constants";

export function getDomain() {
  if (constants.VITE_DOMAIN) {
    return parseDomain(constants.VITE_DOMAIN);
  }

  throw new Error(
    "No domain was specified. Have you set up your .env file? See the README for more information."
  );
}

export function createToken(input: string = "") {
  return window.btoa(input);
}

export function legacyPortalUserToVisitor(
  user?: components["schemas"]["LoggedInUserDetail"]
) {
  return {
    id: user?.id,
    user_created: user?.created,
    email: user?.email,
    last_login: user?.last_login,
    allow_emails: user?.allow_emails,
    certn_staff: user?.is_staff,
    certn_superuser: user?.is_superuser,
    language: user?.lang,
    accept_marketing:
      user?.personal_profile?.profile_preferences?.accept_marketing,
    allow_application_expiration_notifications:
      user?.personal_profile?.profile_preferences
        ?.allow_application_expiration_notifications,
    allow_completed_background_check_notifications:
      user?.personal_profile?.profile_preferences
        ?.allow_completed_background_check_notifications,
    joined_beta_community:
      user?.personal_profile?.profile_preferences?.joined_beta_community,
    profile_created: user?.personal_profile?.created,
    profile_modified: user?.personal_profile?.modified,
    wallet_activation_date: user?.personal_profile?.wallet_activation_date,
    portal_activation_date: user?.personal_profile?.portal_activation_date,
    birth_year: user?.personal_profile?.date_of_birth,
  };
}
